<template>
    <p-secure :require-role="[SECURITYROLES.STOREMANAGER]">
        <p-search-screen
            title="Buyback List Search"
            api-destination="buyback"
            :filters="filters"
            :filterBy="filterBy"
            :fields="buybackListFields"
            :search-message="searchMessage"
            :edit-url-func="item => `/buybacklists/${item.buybackListId}`"
            search-destination="searchbuybacklists"
            ref="sessionSearch"
        >
            <template v-slot:actionButtons>
                <editbuybacklist
                    buyback-list-id="new"
                    @data-saved="updateSessionSearch()"
                />
            </template>
            <template v-slot:filters>
                <h4 class="m-0 pb-3">Filters</h4>
                <p-card class="mb-2 px-2 py-2" no-body>
                    <p-filter-select
                        dataType="locations"
                        label="Locations"
                        v-model="filters.locationIds"
                    />
                </p-card>
                <p-card class="mb-2 px-2 py-2" no-body>
                    <p-filter-select
                        dataType="terms"
                        label="Terms"
                        v-model="filters.termIds"
                    />
                </p-card>
            </template>
            <template v-slot:belowSearch>
                <p-form>
                    <b-row class="mt-4 me-2">
                        <b-col>
                        <p-checkbox
                            label="Open"
                            v-model="filters.open"
                        />
                        <p-checkbox
                            label="Closed"
                            class="ms-3"
                            v-model="filters.closed"
                        />
                        </b-col>
                    </b-row>
                </p-form>
            </template>
        </p-search-screen>
    </p-secure>
</template>
<script>
import editbuybacklist from '@/views/Buyback/EditBuybackList.vue';
import { dateFormatter } from '../../components/Common/Formatters.js';
import SearchStorage from '@/components/mixins/SearchFilterStorage.js';

export default {
    mixins: [SearchStorage],
    components: { editbuybacklist },
    props: {
        id: String,
        searchMessage: {
            type: String,
            default:
                'Search by Description, Session, Purchaser, SKU, ISBN, or Barcode'
        }
    },
    data() {
        return {
            filterName: 'BuybackListFilter',
            buybackListFields: [
                {
                    key: 'session',
                    label: 'Session',
                    sortable: true
                },
                {
                    key: 'list',
                    label: 'Description',
                    sortable: true
                },
                {
                    key: 'purchaser',
                    label: 'Purchaser',
                    sortable: true
                },
                {
                    key: 'createDate',
                    label: 'Create Date',
                    sortable: true,
                    formatter: dateFormatter,
                    sortByFormatted: true
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true
                }
            ],
            filters: {
                automatic: "",
                perPage: 100,
                sortBy: 'list',
                sortDesc: true,
                searchBy: 'All',
                open: true,
                closed: false,
                termIds: [],
                locationIds: []
            },
            filterBy: [
                'All',
                'Description',
                'Session',
                'Purchaser',
                'SKU',
                'ISBN',
                'Barcode'
            ]
        };
    },
    watch: {
        $route: function(to, from) {
            if (to !== from) {
                this.loadData();
            }
        }
    },
    computed: {},
    methods: {
        updateSessionSearch() {
            this.$refs?.sessionSearch.refreshSearchResults();
        }
    }
};
</script>
<style scoped>
.tcw100 {
    width: 100px;
}
</style>
